import React from "react";
import CustomModal from "../CustomModal/CustomModal";
import PartsModalBody from "./PartsModalBody";
import { useStoreSystem } from "../../../store";
import { SectionItemI } from "../../../shared";
import { SectionInterface } from "../../../store/types/store";

type EditItemModalType = {
    editItem: SectionItemI;
    editSection: SectionInterface;
}
const PartsModal: React.FunctionComponent<EditItemModalType> = ({ editItem, editSection }) => {
    const { itemEditModal, setItemEditModal } = useStoreSystem((state) => ({
        itemEditModal: state.itemEditModal,
        setItemEditModal: state.setItemEditModal
    }));

    const onClose = () => {
        setItemEditModal({ isOpen: false, item: undefined, section: undefined });
    }

    return (
        <CustomModal
            isOpenModal={itemEditModal.isOpen}
            onCloseModalCallback={onClose}
        >
            <PartsModalBody editItem={editItem} editSection={editSection} />
        </CustomModal>
    );
};

export default PartsModal;
